/*
 * AES helper frontend.
 * Chave unica da Babita: T_cB@b0918Revend.
 * Uso pontual: cifrar antes de enviar campos sensiveis (senha em login, p.ex).
 */
import CryptoJS from 'crypto-js';

const KEY = 'T_cB@b0918Revend';

export function md5(text) {
    return CryptoJS.MD5(String(text || '')).toString();
}

export function encrypt(text) {
    return CryptoJS.AES.encrypt(String(text || ''), KEY).toString();
}

export function decrypt(cipher) {
    try {
        const bytes = CryptoJS.AES.decrypt(String(cipher || ''), KEY);
        return bytes.toString(CryptoJS.enc.Utf8);
    } catch {
        return '';
    }
}
